import axios from "../utils/axios";

// Stats APIs
export const getOverallStats = (restaurantId) =>
  axios.get(`/api/stats/overall/${restaurantId}`);

export const getCategoryStats = (restaurantId) =>
  axios.get(`/api/stats/categories/${restaurantId}`);

export const getRecentReviews = (restaurantId, limit) =>
  axios.get(`/api/stats/recent-reviews/${restaurantId}`, {
    params: { limit }
  });

export const getPopularTags = (restaurantId) =>
  axios.get(`/api/stats/popular-tags/${restaurantId}`);